<template>
  <d-col cols="12" md="4" lg="4">
    <label for="language">
      {{ $t('order.offerLanguage') }}:
    </label>

    <validation-provider
      rules="required"
      name="language_id"
      v-slot="{ errors }">
      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
        <v-select
          :options="languageOptions"
          v-model="language_id"
          :searchable="false"
          :clearable="false"
          :reduce="language => language.value"
          :placeholder="$t('settings.language.chooseLanguage')"
          label="text">
          <template slot="no-options">
            {{ $t('settings.language.noLanguagesAvailable') }}&hellip;
          </template>
        </v-select>
      </div>

      <div class="invalid-feedback">
        {{ errors[0] }}
      </div>
    </validation-provider>
  </d-col>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'order-select-lang',
  computed: {
    languageOptions () {
      return this.languages.map(language => ({
        value: language.id,
        text: language.code
      }));
    }
  },
  watch: {
    loadError (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-error');
      }
    },
    loadedLanguages (newValue) {
      if (newValue) {
        this.$bus.$emit('order-data-fetch-success', 'langs');
      }
    }
  },
  data () {
    return {
      language_id: null,
      loadedLanguages: false,
      languages: [],
      loadError: false
    }
  },
  mounted () {
    FormUtils.loadAdditionalData(this, {
      method: 'get',
      endpoint: '/languages/items',
      loadedKey: 'loadedLanguages',
      outputKey: 'languages',
      errorKey: 'loadError',
      successAction: () => {
        this.languages.reverse();

        if (this.language_id === null) {
          this.language_id = this.languages[0].id;
        }
      }
    });
  }
}
</script>
